// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1AQkl","inputWrap":"Table_inputWrap__AyHVI","col":"Table_col__SnAzg","bmiTooltip":"Table_bmiTooltip__1ftsA"};